import { Component } from '@angular/core';
import { NavController, ModalController } from 'ionic-angular';
import { DataServiceProvider } from "../../providers/data-service/data-service";
import { DiaperModalComponent } from "../../components/diaper-modal/diaper-modal";

@Component({
  selector: 'page-diapers',
  templateUrl: 'diapers.html',
})
export class DiapersPage {
  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public dataService: DataServiceProvider
  ) {
  }

  newDiaper(){
    let modal = this.modalCtrl.create(DiaperModalComponent,{});
    modal.present();
  }

  openDiaper(diaper:any){
    let modal = this.modalCtrl.create(DiaperModalComponent,{diaper:diaper});
    modal.present();
  }

  removeDiaper(diaper:any){
    this.dataService.removeDiaper(diaper);
  }

}



// WEBPACK FOOTER //
// ./src/pages/diapers/diapers.ts